export function getUser(state, userId) {
  if (!userId) return null
  var user = state.users[userId]

  if (window.__PROD__ && !window.userData && user) {
    window.userData = {
      role: user.roles && user.roles.length > 0 ? user.roles[0].role : '',
      name: user.firstName ? user.firstName : ''
    }

    if (!window._paq) {
      window._paq = []
    }

    window._paq.push(['setCustomDimensionValue', 1, window.userData.name])
    window._paq.push(['setCustomDimensionValue', 2, window.userData.role])
  }

  return user || null
}

export function getUsers(state) {
  return state.users || null
}



// WEBPACK FOOTER //
// ./client/redux/modules/users/selectors.js